import { render, staticRenderFns } from "./StudentList.vue?vue&type=template&id=6b803464"
import script from "./StudentList.vue?vue&type=script&lang=js"
export * from "./StudentList.vue?vue&type=script&lang=js"
import style0 from "./StudentList.vue?vue&type=style&index=0&id=6b803464&prod&lang=scss"
import style1 from "./StudentList.vue?vue&type=style&index=1&id=6b803464&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports